module.exports = __webpack_public_path__ + "img/service-bg.1640d23b.png";